$(document).ready(function(){
    $('body').on('click','.product-item__quick-form .quick-product__label_custom',function(e){
        e.preventDefault();
        var btn = $(this);
        var form = $(this).closest('form');

        // btn.attr('disabled', 'disabled');
        // btn.text('adding...');
        // form.find('.error').remove();
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: form.serialize(),
            dataType: 'json',
            error: function(jqXHR, textStatus, errorThrown){
                // var response = $.parseJSON(jqXHR.responseText);
                // form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
                // btn.text('add to cart');
                // btn.removeAttr('disabled');
            }
            }).done(function( data ) {
                console.log(data);
                // document.addEventListener('cart:build', function() {
                //     theme.CartForm.buildCart();
                // }.bind(this));
                 $.getJSON('/cart.js', function(cart){
                    window.SLIDECART_SET_CART(cart)
                    window.SLIDECART_OPEN() 
                });
                

                // addToCartSuccess();
            // btn.text('add to cart');
            // btn.removeAttr('disabled');
            // refreshCart();
            // $('.productGrid .productItem').removeClass('qvopen');
            // $('body').addClass('cartOpen');
            // $('.PageOverlay').addClass('is-visible');
            // $('.fullPage').addClass('witmenu');
        });

    });
    
});